import { render, staticRenderFns } from "./WishlistList.vue?vue&type=template&id=66689d41&"
import script from "./WishlistList.vue?vue&type=script&lang=js&"
export * from "./WishlistList.vue?vue&type=script&lang=js&"
import style0 from "./WishlistList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports